import { Link } from "~/components/Link";
import { Routes } from "../../routes";
import { getButtonClassName } from "../Button";
import { ButtonVariants } from "../Button";
import { getBadgeClassName } from "~/components/Badge/component";
import { BadgeVariants } from "~/components/Badge/types";
import { cn } from "~/lib/utils";
import { NavigationUserEvents } from "~/modules/analytics/events/navigation";

// // // //

const navbarGhostCtaClassName = getButtonClassName({
    size: "sm",
    rounded: "md",
    variant: ButtonVariants.navbarGhost,
    className: "group shrink-0 gap-1.5",
});

const navbarAnimatedBadgeClassName = cn(
    getBadgeClassName({
        variant: BadgeVariants.blue,
        size: "xs",
        className: "relative h-5 w-9 justify-center overflow-hidden px-0",
    }),
);

export function DataApiCTA(props: { hasApiAccess: boolean }) {
    const href = props.hasApiAccess ? Routes.apiTools : Routes.salesPage;

    return (
        <Link
            href={href}
            className={navbarGhostCtaClassName}
            analyticsLabel={NavigationUserEvents.navbarDataAPICtaClick}
        >
            Enterprise API
            <span className="sr-only">New</span>
            <span aria-hidden="true" className={navbarAnimatedBadgeClassName}>
                <span className="absolute inset-0 flex items-center justify-center transition-all duration-200 ease-out group-hover:-translate-y-full group-hover:opacity-0 motion-reduce:transform-none motion-reduce:transition-none">
                    NEW
                </span>
                <span className="absolute inset-0 flex translate-y-full items-center justify-center text-xs opacity-0 transition-all duration-200 ease-out group-hover:translate-y-0 group-hover:opacity-100 motion-reduce:transform-none motion-reduce:transition-none">
                    {"\u2192"}
                </span>
            </span>
        </Link>
    );
}
